import { Download, FileText, Search } from 'lucide-react';
import manualsData from '../../data/manuals.json';

interface Manual {
  id: number;
  title: string;
  category: string;
  fileSize: string;
  fileType: string;
  version: string;
  lastUpdated: string;
}

const manuals: Manual[] = manualsData;

const categories = ['All', 'Hydraulic Parts', 'Bearings', 'Seals', 'Gears', 'Valves', 'Filters', 'General', 'Safety', 'Maintenance', 'Support'];

export function ManualDownload() {
  return (
    <div className="py-12">
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-5xl mb-4">Manual Download</h1>
          <p className="text-xl text-gray-600">
            Download installation guides, technical manuals, and product documentation
          </p>
        </div>

        {/* Search Bar */}
        <div className="bg-white rounded-lg shadow-md p-6 mb-8">
          <div className="flex flex-col md:flex-row gap-4">
            <div className="flex-1 relative">
              <Search className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400" size={20} />
              <input
                type="text"
                placeholder="Search manuals..."
                className="w-full pl-12 pr-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary"
              />
            </div>
            <select className="px-4 py-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-primary">
              {categories.map((category) => (
                <option key={category} value={category}>
                  {category}
                </option>
              ))}
            </select>
          </div>
        </div>

        {/* Manuals List */}
        <div className="space-y-4">
          {manuals.map((manual) => (
            <div
              key={manual.id}
              className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow"
            >
              <div className="flex flex-col md:flex-row md:items-center justify-between gap-4">
                <div className="flex items-start gap-4 flex-1">
                  <FileText className="text-primary flex-shrink-0 mt-1" size={32} />
                  <div className="flex-1">
                    <h3 className="text-xl mb-2">{manual.title}</h3>
                    <div className="flex flex-wrap gap-4 text-sm text-gray-600">
                      <span className="bg-primary/20 text-primary px-3 py-1 rounded-full">
                        {manual.category}
                      </span>
                      <span>File Type: {manual.fileType}</span>
                      <span>Size: {manual.fileSize}</span>
                      <span>Version: {manual.version}</span>
                      <span>Updated: {manual.lastUpdated}</span>
                    </div>
                  </div>
                </div>
                <button className="bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-lg transition-colors flex items-center gap-2 justify-center">
                  <Download size={18} />
                  Download
                </button>
              </div>
            </div>
          ))}
        </div>

        {/* Additional Info */}
        <div className="mt-12 bg-primary/10 rounded-lg p-8">
          <h2 className="text-2xl mb-4">Need Help?</h2>
          <p className="text-gray-700 mb-4">
            Can't find the manual you're looking for? Our support team is here to help you.
            Contact us and we'll provide the documentation you need.
          </p>
          <button className="bg-primary hover:bg-primary/90 text-primary-foreground px-6 py-3 rounded-lg transition-colors">
            Contact Support
          </button>
        </div>
      </div>
    </div>
  );
}
